import a from"./_Hash.js";import s from"./_ListCache.js";import t from"./_Map.js";var r=a,i=s,o=t;var e=function(){this.size=0,this.__data__={hash:new r,map:new(o||i),string:new r}};export{e as default};
//# sourceMappingURL=_mapCacheClear.js.map
